import React from 'react';
import { abgGraphqlClient, ProxyGraphClients } from '@atlassian/temp-client-utils';
import { usePersistedCacheQuery } from '@css-xp/ppc-custom-hooks';
import {
  FetchAggregatedShipToPartiesForTransactionAccountPpcQuery,
  FetchAggregatedShipToPartiesForTransactionAccountPpcQueryVariables,
  AggregatedShipToPartyOptions,
} from '@css-xp/ppc-graphtypes';
import { CUSTOMERS_PAGE_UTILS } from '@css-xp/ppc-utils';
import { fetchAggregatedShipToPartiesForTransactionAccountPPC } from './queries/ppc-queries/fetch-aggregated-ship-to-parties-ppc';

export const useFetchAggregatedShipToPartiesForTxa = ({
  txaId,
  aggregatedShipToPartyOptions = CUSTOMERS_PAGE_UTILS.buildAggregatedOptions('', undefined),
  isOrgSearchEnabled,
}: {
  txaId: string;
  aggregatedShipToPartyOptions?: AggregatedShipToPartyOptions;
  isOrgSearchEnabled?: boolean;
}) => {
  const ppcBffGraphqlClient = React.useMemo(() => abgGraphqlClient(ProxyGraphClients.PPC_BFF), []);
  return usePersistedCacheQuery<
    FetchAggregatedShipToPartiesForTransactionAccountPpcQuery,
    FetchAggregatedShipToPartiesForTransactionAccountPpcQueryVariables
  >(fetchAggregatedShipToPartiesForTransactionAccountPPC, {
    variables: { id: txaId ?? '', aggregatedShipToPartyOptions, isOrgSearchEnabled },
    skip: !txaId,
    client: ppcBffGraphqlClient,
  });
};
